/**
 * GEGENEREERD BESTAND - niet handmatig aanpassen.
 * Gecontroleerde rijafstanden (Google Routes API, DRIVE, TRAFFIC_UNAWARE)
 * tussen een plaats en een bestemming, als aanvulling op ROUTE_FACTS.
 * Sleutel: "<plaats-slug>|<bestemming>". Bevat geen prijzen: de prijs volgt
 * altijd uit de enige formule in distance-pricing.ts via tariffs.ts.
 * Regenereren: bun scripts/generate-place-distances.ts
 */

export type PlaceDistance = { km: number; min: number };

export const PLACE_DISTANCES: Record<string, PlaceDistance> = {
  "aarlanderveen|breda": { km: 85, min: 61 },
  "abbenbroek|breda": { km: 67, min: 49 },
  "achthuizen|breda": { km: 53, min: 38 },
  "alblasserdam|breda": { km: 48, min: 36 },
  "alkmaar|breda": { km: 150, min: 101 },
  "alphen-aan-den-rijn|breda": { km: 84, min: 60 },
  "amersfoort|breda": { km: 90, min: 65 },
  "ammerstol|breda": { km: 69, min: 58 },
  "amstelveen|breda": { km: 105, min: 78 },
  "amsterdam|breda": { km: 106, min: 76 },
  "arkel|breda": { km: 44, min: 35 },
  "barendrecht|breda": { km: 42, min: 36 },
  "benthuizen|breda": { km: 75, min: 57 },
  "bergambacht|breda": { km: 66, min: 53 },
  "bergschenhoek|breda": { km: 57, min: 47 },
  "berkel-en-rodenrijs|breda": { km: 58, min: 47 },
  "berkenwoude|breda": { km: 62, min: 52 },
  "beverwijk|breda": { km: 130, min: 89 },
  "bilthoven|breda": { km: 77, min: 59 },
  "bleiswijk|breda": { km: 61, min: 52 },
  "bleskensgraaf-ca|breda": { km: 56, min: 43 },
  "bodegraven|breda": { km: 73, min: 52 },
  "boskoop|breda": { km: 73, min: 53 },
  "brandwijk|breda": { km: 50, min: 44 },
  "brielle|breda": { km: 75, min: 54 },
  "bussum|breda": { km: 95, min: 66 },
  "capelle-aan-den-ijssel|breda": { km: 50, min: 37 },
  "castricum|breda": { km: 141, min: 97 },
  "cortelande|breda": { km: 63, min: 44 },
  "dalem|breda": { km: 43, min: 34 },
  "de-lier|breda": { km: 74, min: 54 },
  "de-zilk|breda": { km: 112, min: 79 },
  "delfgauw|breda": { km: 67, min: 54 },
  "delft|breda": { km: 72, min: 55 },
  "den-bommel|breda": { km: 53, min: 39 },
  "den-haag|breda": { km: 78, min: 63 },
  "den-helder|breda": { km: 189, min: 135 },
  "den-hoorn|breda": { km: 70, min: 49 },
  "dirksland|breda": { km: 70, min: 54 },
  "doorn|breda": { km: 84, min: 59 },
  "dordrecht|breda": { km: 36, min: 29 },
  "driebruggen|breda": { km: 80, min: 55 },
  "geervliet|breda": { km: 64, min: 45 },
  "gelderswoude|breda": { km: 77, min: 60 },
  "giessenburg|breda": { km: 40, min: 33 },
  "goedereede|breda": { km: 91, min: 65 },
  "goes|breda": { km: 78, min: 56 },
  "gorinchem|breda": { km: 38, min: 31 },
  "gouda|breda": { km: 70, min: 54 },
  "gouderak|breda": { km: 68, min: 53 },
  "goudriaan|breda": { km: 49, min: 38 },
  "goudswaard|breda": { km: 63, min: 48 },
  "groot-ammers|breda": { km: 50, min: 44 },
  "haarlem|breda": { km: 123, min: 88 },
  "haastrecht|breda": { km: 73, min: 56 },
  "hardinxveld-giessendam|breda": { km: 45, min: 35 },
  "hazerswoude-dorp|breda": { km: 78, min: 60 },
  "hazerswoude-rijndijk|breda": { km: 87, min: 64 },
  "heemskerk|breda": { km: 134, min: 89 },
  "heenvliet|breda": { km: 66, min: 48 },
  "heerhugowaard|breda": { km: 155, min: 103 },
  "heerjansdam|breda": { km: 40, min: 32 },
  "heinenoord|breda": { km: 42, min: 38 },
  "hekelingen|breda": { km: 67, min: 52 },
  "hellevoetsluis|breda": { km: 80, min: 58 },
  "hendrik-ido-ambacht|breda": { km: 38, min: 29 },
  "herkingen|breda": { km: 69, min: 53 },
  "hillegom|breda": { km: 115, min: 79 },
  "hilversum|breda": { km: 87, min: 65 },
  "hoek-van-holland|breda": { km: 81, min: 59 },
  "honselersdijk|breda": { km: 77, min: 55 },
  "hoofddorp|breda": { km: 116, min: 80 },
  "hoogblokland|breda": { km: 46, min: 36 },
  "hoogmade|breda": { km: 98, min: 66 },
  "hoogvliet-rotterdam|breda": { km: 59, min: 45 },
  "hoorn|breda": { km: 150, min: 104 },
  "hoornaar|breda": { km: 42, min: 36 },
  "houten|breda": { km: 69, min: 52 },
  "huizen|breda": { km: 96, min: 67 },
  "hulst|breda": { km: 92, min: 71 },
  "ijmuiden|breda": { km: 130, min: 89 },
  "ijsselstein|breda": { km: 64, min: 48 },
  "kaag|breda": { km: 107, min: 101 },
  "katwijk|breda": { km: 101, min: 74 },
  "kinderdijk|breda": { km: 49, min: 39 },
  "klaaswaal|breda": { km: 45, min: 40 },
  "koudekerk-aan-den-rijn|breda": { km: 89, min: 65 },
  "krimpen-aan-de-lek|breda": { km: 58, min: 48 },
  "krimpen-aan-den-ijssel|breda": { km: 52, min: 40 },
  "kwintsheul|breda": { km: 76, min: 54 },
  "langerak|breda": { km: 53, min: 42 },
  "leerdam|breda": { km: 53, min: 42 },
  "leiden|breda": { km: 96, min: 66 },
  "leiderdorp|breda": { km: 93, min: 65 },
  "leidschendam|breda": { km: 81, min: 57 },
  "leimuiden|breda": { km: 109, min: 75 },
  "lekkerkerk|breda": { km: 62, min: 50 },
  "lisse|breda": { km: 109, min: 78 },
  "maarssen|breda": { km: 77, min: 56 },
  "maasdam|breda": { km: 35, min: 29 },
  "maasdijk|breda": { km: 73, min: 51 },
  "maasland|breda": { km: 68, min: 50 },
  "maassluis|breda": { km: 68, min: 48 },
  "melissant|breda": { km: 72, min: 57 },
  "middelburg|breda": { km: 99, min: 69 },
  "middelharnis|breda": { km: 64, min: 49 },
  "mijnsheerenland|breda": { km: 43, min: 38 },
  "moerkapelle|breda": { km: 66, min: 50 },
  "molenaarsgraaf|breda": { km: 49, min: 42 },
  "monster|breda": { km: 83, min: 62 },
  "mookhoek|breda": { km: 34, min: 29 },
  "moordrecht|breda": { km: 64, min: 46 },
  "naaldwijk|breda": { km: 77, min: 55 },
  "nieuw-beijerland|breda": { km: 54, min: 49 },
  "nieuw-lekkerland|breda": { km: 58, min: 44 },
  "nieuwe-tonge|breda": { km: 61, min: 46 },
  "nieuwe-wetering|breda": { km: 101, min: 68 },
  "nieuwegein|breda": { km: 63, min: 46 },
  "nieuwerbrug-aan-den-rijn|breda": { km: 79, min: 54 },
  "nieuwerkerk-aan-den-ijssel|breda": { km: 60, min: 42 },
  "nieuwkoop|breda": { km: 89, min: 66 },
  "nieuwpoort|breda": { km: 48, min: 41 },
  "nieuwveen|breda": { km: 92, min: 71 },
  "noordeloos|breda": { km: 45, min: 35 },
  "noorden|breda": { km: 96, min: 70 },
  "noordwijk|breda": { km: 103, min: 73 },
  "noordwijkerhout|breda": { km: 106, min: 74 },
  "nootdorp|breda": { km: 70, min: 61 },
  "numansdorp|breda": { km: 53, min: 38 },
  "oegstgeest|breda": { km: 97, min: 69 },
  "ooltgensplaat|breda": { km: 55, min: 39 },
  "oostvoorne|breda": { km: 83, min: 59 },
  "ottoland|breda": { km: 46, min: 39 },
  "oud-ade|breda": { km: 100, min: 68 },
  "oud-alblas|breda": { km: 48, min: 38 },
  "oud-beijerland|breda": { km: 45, min: 42 },
  "ouddorp|breda": { km: 94, min: 69 },
  "oude-tonge|breda": { km: 57, min: 43 },
  "oude-wetering|breda": { km: 104, min: 73 },
  "oudenhoorn|breda": { km: 72, min: 54 },
  "ouderkerk-aan-den-ijssel|breda": { km: 59, min: 48 },
  "papendrecht|breda": { km: 50, min: 37 },
  "pernis-rotterdam|breda": { km: 56, min: 42 },
  "piershil|breda": { km: 61, min: 47 },
  "pijnacker|breda": { km: 65, min: 52 },
  "poeldijk|breda": { km: 79, min: 58 },
  "poortugaal|breda": { km: 54, min: 41 },
  "purmerend|breda": { km: 124, min: 91 },
  "puttershoek|breda": { km: 37, min: 32 },
  "reeuwijk|breda": { km: 72, min: 51 },
  "rhoon|breda": { km: 52, min: 37 },
  "ridderkerk|breda": { km: 41, min: 34 },
  "rijnsaterwoude|breda": { km: 92, min: 73 },
  "rijnsburg|breda": { km: 97, min: 68 },
  "rijpwetering|breda": { km: 103, min: 69 },
  "rijswijk|breda": { km: 74, min: 52 },
  "rockanje|breda": { km: 84, min: 60 },
  "roelofarendsveen|breda": { km: 102, min: 69 },
  "rotterdam-albrandswaard|breda": { km: 52, min: 36 },
  "rotterdam|breda": { km: 51, min: 42 },
  "rozenburg|breda": { km: 69, min: 49 },
  "s-gravendeel|breda": { km: 33, min: 29 },
  "s-gravenzande|breda": { km: 80, min: 59 },
  "sassenheim|breda": { km: 102, min: 70 },
  "schagen|breda": { km: 171, min: 121 },
  "schelluinen|breda": { km: 37, min: 28 },
  "schiedam|breda": { km: 61, min: 48 },
  "schipluiden|breda": { km: 71, min: 51 },
  "schoonhoven|breda": { km: 71, min: 58 },
  "simonshaven|breda": { km: 70, min: 51 },
  "sliedrecht|breda": { km: 49, min: 37 },
  "soest|breda": { km: 88, min: 68 },
  "sommelsdijk|breda": { km: 65, min: 50 },
  "spijkenisse|breda": { km: 62, min: 45 },
  "stad-aan-t-haringvliet|breda": { km: 58, min: 43 },
  "stellendam|breda": { km: 88, min: 62 },
  "stolwijk|breda": { km: 73, min: 55 },
  "streefkerk|breda": { km: 57, min: 43 },
  "strijen|breda": { km: 39, min: 35 },
  "strijensas|breda": { km: 40, min: 35 },
  "ter-aar|breda": { km: 86, min: 62 },
  "ter-heijde|breda": { km: 83, min: 65 },
  "terneuzen|breda": { km: 106, min: 72 },
  "tinte|breda": { km: 77, min: 57 },
  "utrecht|breda": { km: 72, min: 58 },
  "valkenburg|breda": { km: 96, min: 67 },
  "veenendaal|breda": { km: 97, min: 69 },
  "vierpolders|breda": { km: 74, min: 53 },
  "vlaardingen|breda": { km: 60, min: 44 },
  "vlissingen|breda": { km: 101, min: 68 },
  "vlist|breda": { km: 77, min: 62 },
  "volendam|breda": { km: 127, min: 92 },
  "voorburg|breda": { km: 80, min: 55 },
  "voorhout|breda": { km: 102, min: 71 },
  "voorschoten|breda": { km: 88, min: 66 },
  "vrouwenakker|breda": { km: 95, min: 72 },
  "waal|breda": { km: 51, min: 40 },
  "waarder|breda": { km: 78, min: 53 },
  "waddinxveen|breda": { km: 66, min: 49 },
  "warmond|breda": { km: 101, min: 71 },
  "wassenaar|breda": { km: 95, min: 65 },
  "wateringen|breda": { km: 77, min: 56 },
  "westmaas|breda": { km: 44, min: 40 },
  "wijngaarden|breda": { km: 53, min: 39 },
  "woerden|breda": { km: 84, min: 60 },
  "woerdense-verlaat|breda": { km: 94, min: 69 },
  "woubrugge|breda": { km: 91, min: 68 },
  "zaandam|breda": { km: 123, min: 86 },
  "zeist|breda": { km: 77, min: 58 },
  "zevenhoven|breda": { km: 93, min: 69 },
  "zevenhuizen|breda": { km: 62, min: 45 },
  "zierikzee|breda": { km: 79, min: 61 },
  "zoetermeer|breda": { km: 75, min: 57 },
  "zoeterwoude|breda": { km: 91, min: 62 },
  "zuid-beijerland|breda": { km: 54, min: 39 },
  "zuidland|breda": { km: 71, min: 54 },
  "zwammerdam|breda": { km: 77, min: 55 },
  "zwartewaal|breda": { km: 74, min: 52 },
  "zwijndrecht|breda": { km: 36, min: 31 },
};

/** Gecontroleerde rijafstand tussen plaats en bestemming, of null. */
export function placeDistance(placeSlug: string, anchor: string): PlaceDistance | null {
  if (!placeSlug || !anchor || placeSlug === anchor) return null;
  return PLACE_DISTANCES[`${placeSlug}|${anchor}`] ?? null;
}
